'use client';

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useLocationFilter } from '@/hooks/use-location-filter';
import { cn } from '@/lib/utils';

import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { LocationComboBox } from './location-filter-combobox';

type LocationFilterPopoverProps = {
  className?: string;
};

export const LocationFilterPopover = ({
  className,
}: LocationFilterPopoverProps) => {
  const {
    value,
    setValue,
    searchQuery,
    locations,
    isPending,
    isSearching,
    error,
    handleSearch,
    clearLocation,
  } = useLocationFilter();
  const [isOpen, setIsOpen] = useState(false);

  const getButtonText = () => {
    return value === null
      ? 'Select location'
      : value === 'any'
        ? 'Any location'
        : value;
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant='outline-brand'
          className={cn(
            'w-full justify-start font-normal',
            value === null && 'text-muted-foreground',
            className,
          )}
        >
          {getButtonText()}
          <ChevronDown className='ml-auto size-4 shrink-0 opacity-50' />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align='start'
        side='bottom'
        className='p-0'
        style={{ width: 'var(--radix-popover-trigger-width)' }}
      >
        <LocationComboBox
          value={value}
          locations={locations}
          searchQuery={searchQuery}
          isPending={isPending}
          isSearching={isSearching}
          error={error}
          onSearch={handleSearch}
          onClear={() => {
            clearLocation();
            setIsOpen(false);
          }}
          onSelect={(loc) => {
            setValue(loc);
            setIsOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
